import { render, staticRenderFns } from "./OmtkStillageView.vue?vue&type=template&id=049e4cbc&scoped=true"
import script from "./OmtkStillageView.vue?vue&type=script&lang=js"
export * from "./OmtkStillageView.vue?vue&type=script&lang=js"
import style0 from "./OmtkStillageView.vue?vue&type=style&index=0&id=049e4cbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e4cbc",
  null
  
)

export default component.exports